import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, post } from '../services/crud'
import { IEmailValidationModel } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/EmailValidation`

export const validateMultiEmail = createAsyncThunk<
  IEmailValidationModel[],
  string[],
  { rejectValue: APIError }
>('emailValidation/validateMulti', async (emails, thunkApi) => {
  const response = await post(`${baseUrl}/multi`, emails)
  if (response.ok) {
    return await response.json()
  }
  return thunkApi.rejectWithValue(await response.json())
})
